import {writable} from "svelte/store";

export let projects = writable(null);
